module.exports = __webpack_public_path__ + "img/thermometer-01.33075edd.svg";